import type { CrmObject } from '../../core/types';
import type { EntityTypeConfig } from '../registry/entityTypeRegistry';
import { AISummaryPanel } from './AISummaryPanel';
import { HighlightsGrid } from './HighlightsGrid';
import { RecentActivityPreview } from './RecentActivityPreview';
import { RelationshipStatusLine } from './RelationshipStatusLine';

interface OverviewTabProps {
  object: CrmObject;
  config: EntityTypeConfig;
  /** Switches the right-column tab strip to the Activity tab. */
  onViewAllActivity: () => void;
}

export function OverviewTab({
  object,
  config,
  onViewAllActivity,
}: OverviewTabProps) {
  // Lead with the at-a-glance fact tiles, then the human relationship status
  // beneath them, then the AI summary narrative, then the activity timeline.
  const displayName = config.getDisplayName(object);
  return (
    <div className='space-y-6'>
      <HighlightsGrid object={object} highlights={config.highlights ?? []} />
      <RelationshipStatusLine object={object} displayName={displayName} />
      <AISummaryPanel object={object} />
      <RecentActivityPreview
        orgId={object.org_id}
        entityId={object.entity_id ?? ''}
        entityType={object.entity_type_name}
        limit={5}
        onViewAll={onViewAllActivity}
        displayName={displayName}
      />
    </div>
  );
}
